/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-danger */
import React from "react"
import styled from "styled-components"
import tw from "twin.macro"
import PropTypes from "prop-types"

import polygon from "@images/polygon.svg"
import { FolderIcon, Icon } from "@components/icons"

const StyledWorkspace = styled.div`
  ${tw`w-full relative overflow-hidden bg-neutralDark`}

  @media (min-width: 768px) {
    min-height: 60vh;
  }

  & {
    .project-image-screen {
      ${tw`absolute hidden md:block`}
      height: 400%;
      width: 400%;
      top: -25%;
      left: -100%;
      background-size: 800px auto;
      color: var(--neutralDark);
      ${props => props.cover && `background-image: url("${props.cover}");`}
      will-change: transform;
      z-index: 0;

      @media (min-width: 768px) {
        min-height: 60vh;
      }
    }

    .project-description {
      ${tw`relative border border-solid border-suvaGrey rounded-lg md:rounded-none px-4 py-4 md:border-0 flex flex-col-reverse md:flex-col md:justify-center md:w-3/5 lg:py-8 lg:pl-8 lg:pr-10 bg-no-repeat`}

      @media (min-width: 768px) {
        background-image: url("${polygon}");
        background-size: 100% auto;
        background-position: -5px -5px;
        min-width: 40rem;
        filter: drop-shadow(10px -10px 8px rgba(0, 0, 0, 0.5));
        min-height: 60vh;
      }

      h1 {
        ${tw`text-suvaGrey md:text-neutralLight text-xl md:text-3xl font-semibold my-0`}
      }

      .company {
        ${tw`font-mono text-sm`}
      }

      ul {
        ${tw`list-none flex items-center flex-wrap p-0 text-gray-500 gap-x-4 text-sm font-mono`}
      }

      .links {
        ${tw`
            py-2 flex gap-x-4 md:gap-x-0 items-center justify-between mb-4
            md:relative md:top-0 md:right-0 md:border-0 md:p-0 md:mt-4 md:mb-0 
          `}

        svg.feather-folder {
          width: 40px;
          height: 40px;
          ${tw`block md:hidden`}
        }

        .link-item {
          ${tw`flex items-center gap-x-4`}
        }

        a {
          ${tw`text-suvaGrey flex items-center md:border md:border-solid md:border-suvaGrey md:rounded-lg md:px-4 md:py-2 md:transition-all`}

          &:hover {
            ${tw`md:bg-suvaGrey md:bg-opacity-25`}
          }

          .link-text {
            ${tw`hidden md:inline-block md:ml-2`}
          }
        }
      }
    }
  }
`

const Workspace = ({ getNode, idx }) => {
  const { frontmatter, html } = getNode
  const { title, tech, cover, github, external, company } = frontmatter
  const coverData = cover.childImageSharp.fluid.src

  return (
    <StyledWorkspace cover={coverData}>
      <div
        className="project-image-screen scroll-bg"
        style={{ transitionDelay: `${idx + 1}00ms` }}
      />
      <div className="project-description">
        <div>
          <h1>{title}</h1>
          <p className="company">For: {company}</p>
          <p dangerouslySetInnerHTML={{ __html: html }} />

          {tech.length && (
            <ul>
              {tech.map(t => (
                <li key={t}>{t}</li>
              ))}
            </ul>
          )}
        </div>
        <div className="links">
          <FolderIcon />
          <div className="link-item">
            {github && (
              <a
                href={github}
                aria-label="GitHub Link"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon name="GitHub" />
                <span className="link-text">Repository</span>
              </a>
            )}
            {external && (
              <a
                href={external}
                aria-label="Website Link"
                className="external"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon name="External" />
                <span className="link-text">Visit App</span>
              </a>
            )}
          </div>
        </div>
      </div>
    </StyledWorkspace>
  )
}

Workspace.propTypes = {
  idx: PropTypes.number.isRequired,
  getNode: PropTypes.instanceOf(Object).isRequired,
}

export default Workspace
